namespace TabAurous.JobWork {
    export interface JobWorkReturnLaborForm {
        TransItemId: Serenity.StringEditor;
        ItemTypeId: Serenity.LookupEditor;
        AttributeId: Serenity.IntegerEditor;
        ProcessId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        LabourRate: Serenity.DecimalEditor;
        MarkUp: Serenity.DecimalEditor;
        LabourAmount: Serenity.DecimalEditor;
    }

    export class JobWorkReturnLaborForm extends Serenity.PrefixedContext {
        static formKey = 'JobWork.JobWorkReturnLabor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkReturnLaborForm.init)  {
                JobWorkReturnLaborForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(JobWorkReturnLaborForm, [
                    'TransItemId', w0,
                    'ItemTypeId', w1,
                    'AttributeId', w2,
                    'ProcessId', w2,
                    'Pieces', w2,
                    'Weight', w3,
                    'CalcOnId', w1,
                    'LabourRate', w3,
                    'MarkUp', w3,
                    'LabourAmount', w3
                ]);
            }
        }
    }
}
